<template>
  <div>

    <ModalLogin :show="showModal" :error="error" @close="showModal = false"></ModalLogin>

    <div class="w-full h-10 bg-black lg:fixed lg:inset-y-0">
    
    </div>
    <div class="  w-full min-h-screen flex items-center justify-center fondo-modern-fluid"  >
      <div class="min-h-full flex flex-col">
      

        <div   class="pt-1 sm:mx-auto sm:w-full sm:max-w-md" style="z-index: 1000;" >
          <div class="bg-white py-8  shadow-2xl sm:rounded-lg sm:px-6 lg:px-6">
           <div class="flex items-center justify-center text-center p-1 text-blue-800">
            <img src="images/logo.png" width="200" >
           </div> 
            <div class="flex items-center justify-center text-center p-1 text-blue-800">
              {{ this.mensaje }}
            </div>
            <form class="space-y-6 s" @submit.prevent="handleSubmit">
            
              <div>
               
                <div class="mt-1">
                  <input id="userName" v-model="userName" 
                  name="userName" type="text" autocomplete="userName"
                  class=" appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 font-mono text-lg" />

                </div>
                    <p v-if="err_username" class="text-red-500 text-sm mt-2 font-mono">
                       {{  $t('username requerido')}}
                 </p>
              </div>

              <div>
               
                <div class="relative w-full mb-3 mt-0">
                  <input id="password" v-model="password" name="password" :type="type0" autocomplete="current-password" 
                  class="text-lg appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm 
                  placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500" />

                  <div class=" absolute inset-y-0 right-0 pr-3 flex items-center text-lg leading-5  font-mono">
                    <p class=" mt-1 font-mono"> <a @click="showPassword" class="font-mono">{{ btnText0 }}</a></p>
                  </div>
                  
                  <p v-if="err_password" class="text-red-500 text-sm mt-2 font-mono">
                       {{  $t('password requerida')}}
                  </p>

                </div>
              </div>



          


              <div>
                <div v-if="loading">
                 <div  class="w-10 h-10 mx-auto border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>  
                </div>
                <button v-else type="submit" 
                  class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm   text-lg font-mono text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                  {{ $t('entrar') }}
                </button>
                
                <img v-if="qrDataUrl" :src="qrDataUrl" alt="QR OTP" />
                <span v-if="qrDataUrl">Escanee QR</span>
              
              </div>
            </form>
          </div>

          
        </div>
      </div>
    </div>
    <div v-if="isOnline == false" class="sticky bottom-0 bg-red-500 text-white text-center py-4"
      style='z-index:10000000'>
      <p>{{ $t('sinconexion') }}</p>
    </div>
  </div>
</template>
 
<style>
.fondo-modern-fluid {
  position: relative;
  width: 100%;
  min-height: 100vh;
  background: radial-gradient(circle at 20% 30%, #0a0f1e, #03050b);
  overflow: hidden;
  isolation: isolate;
  z-index: 1;
}

/* Capa principal de gradiente cónico animado */
.fondo-modern-fluid::before {
  content: '';
  position: absolute;
  inset: -30%;
  background: conic-gradient(from 0deg, 
    #ff2d95, 
    #ff6b2d, 
    #f9e45b, 
    #2bd9ff, 
    #b82dff, 
    #ff2d95
  );
  animation: rotarGradiente 12s linear infinite;
  filter: blur(60px);
  opacity: 0.55;
  mix-blend-mode: screen;
  pointer-events: none;
  z-index: 0;
}

/* Segunda capa con movimiento fluido y escala */
.fondo-modern-fluid::after {
  content: '';
  position: absolute;
  inset: -20%;
  background: radial-gradient(circle at 40% 50%, rgba(255, 80, 200, 0.4), transparent 60%),
              radial-gradient(circle at 80% 70%, rgba(0, 255, 255, 0.35), transparent 55%);
  animation: flotarYEscalar 5s ease-in-out infinite alternate;
  filter: blur(50px);
  mix-blend-mode: overlay;
  pointer-events: none;
  z-index: 1;
}

/* Tercera capa (opcional) con textura sutil y brillo */
.fondo-modern-fluid .capa-textura {
  position: absolute;
  inset: 0;
  background-image: repeating-linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.02) 0px,
    rgba(255, 255, 255, 0.02) 2px,
    transparent 2px,
    transparent 8px
  );
  pointer-events: none;
  z-index: 2;
}

/* Animaciones */
@keyframes rotarGradiente {
  0% {
    transform: rotate(0deg) scale(1);
  }
  50% {
    transform: rotate(180deg) scale(2);
  }
  100% {
    transform: rotate(360deg) scale(1);
  }
}

@keyframes flotarYEscalar {
  
}
</style>
 
<script>
import { ref } from 'vue'
import { mapActions } from "vuex";
import router from "../../router";
import ModalLogin from "./ModalLogin";
import DOMPurify from "dompurify";
//import vueRecaptchaEsp from "vue3-recaptcha2";
import i18n from '@/i18n';
 
export default {
  name: "LoginRootCaptcha",
  components: {
  //  vueRecaptchaEsp,
    ModalLogin,
  },
  created() {
    this.checkInternet();
    window.addEventListener("online", this.checkInternet);
    window.addEventListener("offline", () => (this.isOnline = false));
  },
  mounted() {
    window.localStorage.removeItem("user");

    if (typeof window !== 'undefined') {
      document.addEventListener('click', this.handleClickOutside)


    }
    const l = i18n.global.locale.value;
    console.log('lang', l)
  },
  data() {
    return {
      visible:true,
      type0: 'password',
      isOnline: false,
      showRecaptcha: true,
      loadingTimeout: 30000, // 30 seconds
      userName: "",
      password: "",
      showModal: false,
      status: "0",
      token: "",
      mensaje: "",
      verificado: false,
      keycliente: "6LdgnAcpAAAAAJHBHchPcK5qJjGc1oEa55pFpJTr",
      showDropdown: false,
      dropdownRef: { value: ref(null) },
      btnText0: ref(i18n.global.t('mostrar')),
      hl: '',
      err_password:false,
      err_username:false,
      qrDataUrl:'',
      loading:false,
    };
  },
  methods: {
    ...mapActions("auth", ["login"]),
    showPassword() {

      if (this.type0 === 'password') {
        this.type0 = 'text'
        this.btnText0 = i18n.global.t('ocultar')
      } else {
        this.type0 = 'password'
        this.btnText0 = i18n.global.t('mostrar')
      }
    },
    async checkInternet() {
      try {

        await fetch("https://www.google.cl", { mode: "no-cors" });
        this.isOnline = true;
      } catch (error) {
        this.isOnline = false;
      }
    },
    updModal() {
      this.showModal = true;
    },
    async handleSubmit() {

        this.err_username = this.userName === '';
      this.err_password = this.password === '';
      if(this.err_username || this.err_password ){
          return false;
      }
       

      try {
        this.mensaje =   i18n.global.t('enviando datos...');
        this.$store.state.auth.statusLogin='';
        let e = DOMPurify.sanitize(this.userName);
        let p = DOMPurify.sanitize(this.password);
        this.loading=true;
         await this.$store.dispatch("login_QR", { e, p });
        //await this.$store.dispatch("login", { e, p });FV
        
        //const status=this.$store.state.auth.statusLogin.status
        const status=this.$store.state.auth.statusLogin.status
         
        if (status == "OTP_SETUP_REQUIRED"){
           router.push("/otpsetupqr");
           return true;
        }
        if (status == "OTP_REQUIRED"){
          router.push("/otpsetupcode")
          return true;
        }
        if (status == 200) {
         
          router.push("/home");
        } else {
          this.loading=false;
          if (status == 300) {
            this.error =   i18n.global.t('error_datos_novalidos');
            this.updModal();
           
          } else {
            if ([404].includes(status)) {
              this.error =  i18n.global.t('error_servicios_nodisponibles');
              this.updModal();
            } else {
              this.error =i18n.global.t('Datos incorrectos');
              this.updModal();
              this.mensaje =""
            }
          }
        }
      } catch (err) {
        this.error =i18n.global.t('error_interno_servidor');
        this.updModal();
        console.log(err);
        this.mensaje = err;
      }
    },
    async recaptchaVerified(response) {
      console.log("respuesta", response);

      const url = "https://www.google.com/recaptcha/api/siteverify";
      const token = response;
      const clave = this.keycliente;
      const data = {
        Secret: clave,
        respuesta: token,
      };

      fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Respuesta del servidor:", data);
          // Realizar acciones adicionales con la respuesta del servidor
        })
        .catch((error) => {
          console.error("Error al realizar la solicitud POST:", error);
          // Manejar errores
        });

      this.verificado = true;
    },
    recaptchaExpired() {
      this.$refs.vueRecaptcha.reset();
    },
    recaptchaFailed() { },
    recaptchaError(reason) {
      console.log("reason", reason);
    },


    toggleDropdown() {
      this.showDropdown = !this.showDropdown
    },

    selectLanguage(lang) {
      console.log('Idioma seleccionado:', lang)

      const l = ref(i18n.global.locale.value);
      console.log('lang', l)

      i18n.global.locale.value = lang;
      localStorage.setItem('lang', lang);

      this.btnText0 = i18n.global.t('mostrar');
     

      this.showDropdown = false
     
      if (lang == 'en') {
        console.log('redirige')
        this.visible=false
        parent.window.location.href = '/en';
      }

    },

    handleClickOutside(event) {
      console.log('event', event._vts)
      if (
        !event._vts
      ) {
        this.showDropdown = false
      }
    },


    reloadRecaptchaScript(hl) {
      const oldScript = document.querySelector('script[src^="https://www.google.com/recaptcha/api.js"]');
      if (oldScript) {
        document.head.removeChild(oldScript);
      }

      return new Promise((resolve) => {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=explicit&hl=${hl}`;
        script.async = true;
        script.defer = true;
        script.onload = resolve;
        document.head.appendChild(script);
      });
    }


  },
  watch: {
    async hl(value) {
      this.reloadRecaptchaScript(value)

    },
  },

}
</script>
